import { render, staticRenderFns } from "./ListMore.vue?vue&type=template&id=54168f20&scoped=true"
import script from "./ListMore.vue?vue&type=script&lang=js"
export * from "./ListMore.vue?vue&type=script&lang=js"
import style0 from "./ListMore.vue?vue&type=style&index=0&id=54168f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54168f20",
  null
  
)

export default component.exports